import { Reveal } from "./motion/Reveal";

/** Editorial section heading with eyebrow label + large left-aligned title. */
export function SectionHeading({ eyebrow, title, description, light = false, className = "", align = "left" }) {
  const alignCls = align === "center" ? "text-center mx-auto items-center" : "text-left";
  return (
    <Reveal className={`flex flex-col ${alignCls} max-w-3xl ${className}`}>
      {eyebrow && (
        <span
          className={`text-sm font-semibold uppercase tracking-[0.22em] mb-4 ${
            light ? "text-accent2" : "text-accent2"
          }`}
        >
          {eyebrow}
        </span>
      )}
      <h2
        className={`font-heading text-4xl md:text-5xl font-bold tracking-tight leading-tight ${
          light ? "text-white" : "text-navy"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p className={`mt-6 text-base md:text-lg leading-relaxed ${light ? "text-lightgray/90" : "text-steel"}`}>
          {description}
        </p>
      )}
    </Reveal>
  );
}
